import React, { Component } from 'react';

import Select from 'react-select';

import ErrorSummary from '../components/error-summary';
import ActivityIndicator from '../components/activity-indicator'
import authentication_api from '../api/authentication';

interface Props {
    isOpen: boolean;
    onClose: () => void;
}

interface State {
    loading: boolean;
    errorMessages: string[];
    oauth_providers: any[];
    selected_oauth_provider: any | null;
    well_known_url: string;
    provider: string;
    client_id: string;
    client_secret: string;
    client_secret_censored: string;
    scope: string;
    authorization_url: string;
    token_url: string;
}

class ModalOauthSettings extends Component<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            loading: false,
            errorMessages: [],
            oauth_providers: [],
            selected_oauth_provider: null,
            well_known_url: '',
            provider: '',
            client_id: '',
            client_secret: '',
            client_secret_censored: '',
            scope: 'openid email',
            authorization_url: '',
            token_url: '',
        };

        this.onChange = this.onChange.bind(this);
        this.onClickSave = this.onClickSave.bind(this);
        this.getAllOrgOAuthProviders = this.getAllOrgOAuthProviders.bind(this);
        this.getOrgOAuthSettings = this.getOrgOAuthSettings.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
    }

    async componentDidMount() {
        // get current oauth settings
        try{
            await this.getAllOrgOAuthProviders();
        }
        catch (error) {
            // @ts-ignore
            this.setState({ errorMessages: [error.message] });
        }
        finally {
            this.setState({ loading: false });
        }
    }

    async resetState() {
        this.setState({
            loading: false,
            errorMessages: [],
            selected_oauth_provider: null,
            well_known_url: '',
            provider: '',
            client_id: '',
            client_secret: '',
            client_secret_censored: '',
            scope: 'openid email',
            authorization_url: '',
            token_url: '',
        })
    }

    async getAllOrgOAuthProviders() {
        this.setState({ errorMessages: [], loading: true });
        try{
            let all_oauth_providers = await authentication_api.get_all_oauth_providers();

            this.setState({
                oauth_providers: all_oauth_providers.map((provider: any) => ({
                    value: provider.id,
                    label: provider.provider
                })),
                loading: false
            })
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }
    }

    async getOrgOAuthSettings(provider_id: string) {
        this.setState({ errorMessages: [], loading: true });
        try{
            let oauthSettings = await authentication_api.get_oauth_settings(provider_id);

            if (oauthSettings){
                if (oauthSettings.org_configs) {

                    this.setState({
                        client_id: oauthSettings.org_configs.client_id || '',
                        client_secret: oauthSettings.org_configs.client_secret || '',
                        client_secret_censored: this.censorString(oauthSettings.org_configs.client_secret || ''),
                        scope: oauthSettings.org_configs.scope || 'email openid',
                    });
                }
                if (oauthSettings.provider_configs){
                    this.setState({
                        well_known_url: oauthSettings.provider_configs.oidc_server || '',
                        provider: oauthSettings.provider_configs.provider || '',
                        authorization_url: oauthSettings.provider_configs.redirect_url || '',
                        token_url: oauthSettings.provider_configs.authorization_url || ''
                    });
                }
            }

            this.setState({ errorMessages: [], loading: false });
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }
    }

    isValidUrl = (url: string) => {
        const pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
        '((([a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)\\.)+[a-z]{2,6})'+ // domain name
        '(:[0-9]{1,5})?(\\/.*)?$','i'); // port and path
        return !!pattern.test(url);
    };

    censorString(str: string){
        if (str.length > 8) {
            let visiblePart = str.slice(-8);
            let censoredPart = '*'.repeat(str.length - 8);
            return censoredPart + visiblePart;
        }
        return str;
    }

    // @ts-ignore
    onChange(e) {
        if (e.target.name == "client_secret") {
            let value = e.target.value;

            // Derive the difference from previous censored value
            const newChar = value.length > this.state.client_secret_censored.length
            ? value.slice(-1) // typing
            : null; // backspace or deletion

            let uncensored_client_secret = this.state.client_secret;

            if (newChar) {
                // Add character
                uncensored_client_secret += newChar;
            } else {
                // Handle backspace
                uncensored_client_secret = uncensored_client_secret.slice(0, -1);
            }

            this.setState({ client_secret: uncensored_client_secret, client_secret_censored: this.censorString(value) });
        }
        else{
            // @ts-ignore
            this.setState({ [e.target.name]: e.target.value }, async () => {
                if (e.target.name == "well_known_url") {
                    // check if well known URL is a real URL

                    if (!this.isValidUrl(this.state.well_known_url)) {
                        this.setState({ errorMessages: ['Well Known URL is not a valid URL.'] });
                    }
                    else{
                        this.setState({ errorMessages: [], loading: true });
                        try{
                            const response = await fetch(this.state.well_known_url);
                            if (!response.ok) {
                                throw new Error(`Response status: ${response.status}`);
                            }

                            const wellKnownDetails = await response.json();
                            this.setState({
                                authorization_url: wellKnownDetails.authorization_endpoint || '',
                                token_url: wellKnownDetails.token_endpoint || '',
                                errorMessages: []
                            });
                        } catch (error) {
                            // @ts-ignore
                            this.setState({ errorMessages: ["No Well Known Details found."] });
                        } finally {
                            this.setState({ loading: false });
                        }
                    }
                }
            });
        }
    }

    async onSelectChange(selectedOption: any) {
        try{
            this.setState({ selected_oauth_provider: selectedOption, errorMessages: [], loading: true });

            let provider_id = selectedOption ? selectedOption.value : null;

            if (provider_id == null) {
                this.resetState();
            }
            else{
                await this.getOrgOAuthSettings(provider_id);
            }

            this.setState({ errorMessages: [], loading: false });
        }
        catch(e){
            // @ts-ignore
            this.setState({ errorMessages: [e.message], loading: false });
        }

    }

    async onClickSave() {
        this.setState({ errorMessages: [], loading: true })
        try {
            let payload = {
                provider_id: this.state.selected_oauth_provider ? this.state.selected_oauth_provider.value : null,
                provider: this.state.provider,
                oidc_server: this.state.well_known_url,
                client_id: this.state.client_id,
                client_secret: this.state.client_secret,
                scope: this.state.scope,
                authorization_url: this.state.authorization_url,
                token_url: this.state.token_url
            }

            let response = await authentication_api.save_oauth_settings(payload);

            if (response) {
                this.props.onClose();
            } else {
                this.setState({ errorMessages: ['Failed to save OAuth settings.'] });
            }

        } catch (error) {
            // @ts-ignore
            this.setState({ errorMessages: [error.message] })
        } finally {
            this.setState({ loading: false })
        }
    }

    render() {
        return (
            <div role="dialog"
                onClick={() => this.props.onClose()}
                style={{ display: ((this.props.isOpen) ? 'block' : 'none') }}
                className={"modal fade " + ((this.props.isOpen) ? 'in' : '')}>


                <div className="modal-dialog modal-lg" role="document" onClick={(e) => e.stopPropagation()}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <button
                                onClick={() => this.props.onClose()}
                                type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <i className="fa fa-close"></i>
                            </button>
                            <h4 className="modal-title text-white text-capitalize">OAuth Settings</h4>
                        </div>
                        <div className="modal-body">

                            <ErrorSummary errorMessages={this.state.errorMessages} />

                            <React.Fragment>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Providers</label>
                                            <Select
                                                value={this.state.selected_oauth_provider}
                                                onChange={(item) => {
                                                    this.onSelectChange(item);
                                                }}
                                                className='react-select-container'
                                                classNamePrefix="react-select"
                                                isClearable={true}
                                                placeholder=""
                                                options={this.state.oauth_providers}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Well Known URL</label>
                                            <input
                                                name="well_known_url"
                                                value={this.state.well_known_url}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Well Known URL" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Provider Name</label>
                                            <input
                                                name="provider"
                                                value={this.state.provider}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Provider" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Client ID</label>
                                            <input
                                                name="client_id"
                                                value={this.state.client_id}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Client ID" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Client Secret</label>
                                            <input
                                                name="client_secret"
                                                value={this.state.client_secret_censored}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Client Secret" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Scope</label>
                                            <input
                                                name="scope"
                                                value={this.state.scope}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Scope" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Authorization URL</label>
                                            <input
                                                name="authorization_url"
                                                value={this.state.authorization_url}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Authorization URL" />
                                        </div>
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-8 col-xs-12">
                                        <div className="form-group">
                                            <label className="font-weight-600 text--capitalize">Token URL</label>
                                            <input
                                                name="token_url"
                                                value={this.state.token_url}
                                                onChange={(e) => this.onChange(e)}
                                                type="text" className="form-control" placeholder="Token URL" />
                                        </div>
                                    </div>
                                </div>

                            </React.Fragment>

                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => this.props.onClose()}
                                className="btn btn-light-outline no-margin-right">Cancel</button>
                            <button
                                onClick={() => this.onClickSave()}
                                className="btn btn-dark">{this.state.selected_oauth_provider ? "Update" : "Add"}</button>

                            <ActivityIndicator
                                modal={true}
                                loading={this.state.loading}
                            />

                        </div>
                    </div>
                </div>
            </div>

        )
    }

}

export default ModalOauthSettings;
